<template>
    <section class="chart-container" >
        <div class=" ml30 mr30" >
            <!--记录查询页 s-->
                <div class=" mb15 row flex-start">
                    <div class="row flex-start"><div>场地名称：</div>
                    <el-select ref="selectValue1" v-model="optionValue" @change="optionValueChange" filterable placeholder="请选择" class="mr25">
                        <el-option
                                v-for="item in optionList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        />
                    </el-select>
                    </div>
                </div>

            <div class="row flex-between mt15 mb15">
                <div class="row flex-start">
                    <div class=" row flex-center font24 grey6_text cursorp white_bg mr15"  @click="onEdit('new')" style="width:180px;height:60px;border: 1px solid rgba(227, 232, 238, 1);">新增</div>
                    <div class=" row flex-center font24 grey6_text cursorp white_bg mr15"  @click="onEdit()" style="width:180px;height:60px;border: 1px solid rgba(227, 232, 238, 1);">编辑</div>
                    <div class=" row flex-center font24 grey6_text cursorp white_bg mr15"  @click="onGuige()" style="width:180px;height:60px;border: 1px solid rgba(227, 232, 238, 1);">添加规格</div>
                    <div class=" row flex-center font24 grey6_text cursorp white_bg mr15"  @click="editFuc('ENABLE')" style="width:180px;height:60px;border: 1px solid rgba(227, 232, 238, 1);">启用</div>
                    <div class=" row flex-center font24 grey6_text cursorp white_bg mr15"  @click="editFuc('DISABLE')" style="width:180px;height:60px;border: 1px solid rgba(227, 232, 238, 1);">禁用</div>
                </div>
            </div>


                <template>
                    <el-table
                            v-loading = "isLoading"
                            element-loading-background = "rgba(255, 255, 255, .5)"
                            :element-loading-text = "loadText"
                            element-loading-spinner = "el-icon-loading"
                            :height="recoData.recParams.page_size==10?570:570"
                            :data="recoData.list"
                            :row-style="rowStyle"
                            @row-click="changeCurrentRow"
                    >
                        <el-table-column
                                prop="Num"
                                label="货物编号">
                        </el-table-column>
                        <el-table-column
                                prop="Name"
                                label="货物名称">
                        </el-table-column>
                        <el-table-column
                                prop="Comment"
                                label="备注">
                        </el-table-column>
                        <el-table-column
                                prop="guigedetail"
                                label="规格数">
                        </el-table-column>
                        <el-table-column
                                prop="Valid"
                                label="启用/禁用">

                            <template slot-scope="scope">
                                <span v-if="scope.row.Valid == 1" class="green_text">已启用</span>
                                <span v-if="scope.row.Valid == 0" class="red_text">已禁用</span>
                            </template>
                        </el-table-column>
                    </el-table>
                     <div class="row flex-between">
                         <div></div>
                         <div class="row flex-start font12">
                             <el-pagination background layout="total,sizes,prev, pager, next"     :page-size="recoData.recParams.page_size"  :page-sizes="[10,20,30,40,50,100,200,500,1000,2000]" :total="recoData.total"  popper-class='select_bottom'
                                           v-model:currentPage="recoData.recParams.page" v-model:page-size="recoData.recParams.page_size"
                                           @current-change="handleCurrentChange" @size-change="handleSizeChange" style="margin: 20px 0 20px 0;" />
                         </div>
                     </div>
                </template>
            <!--记录查询页 e-->

            <!--编辑规格弹窗-->
            <el-dialog :title="title" :visible.sync="show02"  @closed="handleClose" :close-on-click-modal="true"  append-to-body="true" >
                <el-form :model="form2" :rules="rules2" ref="ruleForm2">
                    <el-button type="primary" size="mini"  @click="addLenght" >添加规格</el-button>
                    <div class="mb10"></div>
                            <el-table :data="form2.tableData" :cell-style="{background:'#fff'}"
                                      :row-style="rowStyle"
                                      element-loading-background = "rgba(255, 255, 255, .5)"
                                      style="width: 100%;"  border ref="tableDemo">
                                <el-table-column type="index" width="55" label="序号" align="center"></el-table-column>
                                <el-table-column label="规格" prop="name" min-width="120"  align="center">
                                    <template #default="scope">
                                        <el-form-item :prop="'tableData.'+scope.$index+'.name'" :rules='rules2.name'>
                                            <el-input v-model="scope.row.name"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作"  min-width="120"  align="center">
                                    <template #default="scope">
                                        <div>
                                            <el-button type="text" @click="removeItem(scope.$index)">删除</el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="show02 = false">取 消</el-button>
                    <el-button type="primary" @click="saveGuige()">确 定</el-button>
                </div>
            </el-dialog>
            <!--编辑弹窗-->
            <el-dialog :title="title" :visible.sync="show01"  @closed="handleClose" :close-on-click-modal="false"  append-to-body="true" >
                <el-form :model="form" :rules="rules" ref="ruleForm">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="物资编号"  prop="Num"  min-width="290">
                                <el-input v-model="form.Num" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="物资名称"  prop="Name">
                                <el-input v-model="form.Name"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="form.Comment"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="show01 = false">取 消</el-button>
                    <el-button type="primary" @click="editFuc('NEW')" v-if="title=='新增物资'">确 定</el-button>
                    <el-button type="primary" @click="editFuc()" v-else>确 定</el-button>
                </div>
            </el-dialog>


        </div>
    </section>
</template>

<script>
    import axios from "axios";
    import { showLoading, hideLoading } from '../utils/common.js';

    export default {
        data() {
            return {
                optionList: [],
                optionValue: '',
                user: JSON.parse(window.localStorage.getItem('user')),
                isLoading:false,//表格加载
                loadText:'正在加载…请耐心等待',
                loadText1:'正在加载…请耐心等待',
                loadText2:'数据比较多正在加载…请耐心等待',
                show01:false,//编辑弹窗
                show02:false,//编辑规格弹窗
                form:{
                    Num: '',
                    Name: '',
                    Spec: '',
                    Type: '',
                    Comment: ''
                },
                form2:{
                    tableData:[
                        {name:''}
                    ]
                },
                rules: {
                  Name:{ required: true, message: '请输入物资', trigger: 'blur' },
                  Num:{ required: true, message: '请输入编号', trigger: 'blur' }
                },
                rules2: {
                  name:{ required: true, message: '请输入规格', trigger: 'blur' }
                },
                title:'编辑物资',
                title2:'编辑物资规格',
                title3:'新增物资',
                recoData:{
                    currentRowId:'',//当前选中行的id
                    list:[],//表格list
                    total:0,//表格toal
                    keywords:'',
                    recParams:{
                        machine_code:'',
                        page_size:10,
                        page:1,
                    },
                }
            }
        },
 mounted: function () {
            this.resetData()
  		    this.getoptionList()
        },
        methods: {
//记录查询页 s

        optionValueChange(e){
                    this.onRefresh2()
        },
     resetData() {
            this.recoData.currentRowId=''
            this.recoData.list=[];
            this.recoData.total=0;
            this.recoData.keywords='';
            this.recoData.recParams.page=1;
            this.recoData.recParams.page_size=10;
     },
         onRefresh2() {
            this.resetData()
            self.getRecoredList()
         },

addLenght(){
let item={name:''}
this.form2.tableData.push(item)
},
   //删除行
     removeItem(index){
     let self=this
      if(this.form2.tableData.length>1){
           this.form2.tableData.splice(index,1);
      }else{
            self.$message({type: 'warning',message: '不允许全部删除'});
      }
     },
handleClose () {
      //this.$refs.ruleForm.resetFields()
    },
    handleSave () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.editFuc()
        } else {
          console.log('输入错误')
        }
      })
    },


onGuige(){
            let self=this
            if(this.recoData.currentRowId==''){
            return;
            }
            this.title="设置规格"
            this.show02=!this.show02
let params={"goods_uuid":this.recoData.currentRowId}
            self.$axios.get(self.baseApiUrl+'appointment/get_goodSpec',{params:params}).then(function (res) {
             if(res.data.code==1){
                        if(res.data.data.length>0){
                        console.log("大于0")
                            let guigeList = res.data.data.map(function(i) {
                               return i.Name
                            })
                        console.log("guigeList")
                        console.log(guigeList)
                            let a=guigeList[guigeList.length-1].split(",")
                        console.log("a")
                        console.log(a)
                            a.pop()
                        console.log("apop")
                        console.log(a)
                            let c=[]
                            a.forEach((item,index)=>{
                               c.push(
                                   Object.assign({},
                                       {'name':item})
                               )
                            })
                            self.form2.tableData=c
                        }
             }
            })
},
saveGuige(){
        let self=this
        let namestr=''
        let textV='添加成功'
        for(let i=0;i<self.form2.tableData.length;i++){
        let item=self.form2.tableData[i].name
        namestr+=item+","
        }
        let paramsV={
        "goods_uuid":this.recoData.currentRowId,
        "Name":namestr
        }
        self.$axios.post(self.baseApiUrl+'account4/admin/goods/addSpec',paramsV).then(function (res) {
          self.show01 = false
         if(res.data.code==1){
            self.$message({type: 'success',message: textV});
            self.onRefresh2()
         }
        })
},

          onEdit(e){
            if(this.recoData.currentRowId==''&&e!='new'){
            return;
            }
            if(e=='new'){
            this.title="新增物资"
            let random1 =Math.random().toString(36).substr(2);
            this.recoData.currentRowId=''
             this.form = {
                Num:'9af7f46a-ea52-4aa3-b8c3-'+random1,
                Name: '',
                Spec: '',
                Type: '',
                Comment: '',
                tableData: [
                        {name:''}
                    ]
              }
            }else{
            this.title="编辑物资"
            //this.getDetail()
            }
            this.show01=!this.show01
            },
editFuc(ValidVal){//编辑接口
let self=this


let params={'model':'goods','uuid':this.recoData.currentRowId,'Num':self.form.Num,'Name':self.form.Name,'Comment':self.form.Comment}
let params2={'model':'goods','uuid':this.recoData.currentRowId,'Valid':ValidVal=='ENABLE'?1:0}
let params3={'machine_code':self.optionValue,Id:'','Valid':1,'Num':self.form.Num,'Name':self.form.Name,'Comment':self.form.Comment}
let paramsV=ValidVal=='NEW'?params3:(ValidVal=='ENABLE'||ValidVal=='DISABLE')?params2:params
let textV=ValidVal=='NEW'?'新增成功':ValidVal=='ENABLE'?'已启用':ValidVal=='DISABLE'?'已禁用':'编辑成功'
               if(ValidVal=='ENABLE'||ValidVal=='DISABLE'){
                    if(this.recoData.currentRowId==''){
                    return;
                    }
                    let text=ValidVal=='ENABLE'?'是否确认启用？':'是否确认禁用？'
                   this.$confirm(text, '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning',
                          center: true
                    }).then(() => {
                    self.editApi(paramsV,textV)
                    })
                }
                else{
                      this.$refs.ruleForm.validate((valid) => {
        if (valid) {

                       if(ValidVal=='NEW'){
                        self.addApi(paramsV,textV)
                    }else{
                        self.editApi(paramsV,textV)
                    }
                }
  })
                  }

},

editApi(paramsV,textV){
        let self=this
        self.$axios.post(self.baseApiUrl+'account4/machine_data/machine_data/edit',paramsV).then(function (res) {
          self.show01 = false
         if(res.data.code==1){
            self.$message({type: 'success',message: textV});
            self.onRefresh2()
         }
        })
},
addApi(paramsV,textV){
        let self=this
        self.$axios.post(self.baseApiUrl+'account4/admin/goods/add',paramsV).then(function (res) {
          self.show01 = false
         if(res.data.code==1){
            self.$message({type: 'success',message: textV});
            self.onRefresh2()
         }
        })
},




getDetail(){//获取物资详情
let self=this
let params={goods_uuid:this.recoData.currentRowId}
self.$axios.get(self.baseApiUrl+'appointment/get_goodSpec',{params:params}).then(function (res) {
 if(res.data.code==1){
    console.log("res.data.data编辑数据")
    self.form=res.data.data
 }
})
},



         getRecoredList(e){
         let self=this
            self.isLoading = true;
         let recParams=self.recoData.recParams
         if(recParams.page_size>100){
         self.loadText=self.loadText2
         }else{
         self.loadText=self.loadText1
         }
         recParams.machine_code=self.optionValue

               this.$axios.get(this.baseApiUrl+'appointment/get_goods',{"params": recParams}).then(function (res) {

            self.isLoading = false;
                if(res.data.code==1){
                    self.recoData.list=res.data.data
                    self.recoData.total=res.data.data.total
                     self.recoData.list.map((i)=>{
                        if(i.all_goods_spec.length>0){
                        return i.guigedetail=i.all_goods_spec[i.all_goods_spec.length-1].name
                        }
                     })
                     console.log("self.recoData.list 226")
                     console.log(self.recoData.list)

                }


            })
        },



        handleSizeChange (val) {
            this.recoData.recParams.page_size = val
            this.getRecoredList()
        },
        handleCurrentChange  (val) {
            this.recoData.recParams.page = val
            this.getRecoredList()
        },










            changeCurrentRow(row, column, event) {
              if (this.recoData.currentRowId === row.uuid){
              this.recoData.currentRowId = ''
              }else{
              this.recoData.currentRowId = row.uuid
              this.form=row
              this.form2.tableData=[
                        {name:''}
                    ]
              }
            },
            rowStyle ({row, rowIndex}) {
              if (this.recoData.currentRowId === row.uuid) {
                // 此处返回选中行的样式对象，按需设置
                return {
                  'background-color': '#e3e8ee',
                }
              }
            },

//记录查询页 e
getoptionList(){
let self=this
 let machparam={type:2}
        self.$axios.post(self.baseApiUrl+'rsa/get_machine_code_list',machparam).then(function (res) {
            console.log("get_machine_code_list-res")
            console.log(res.data.data)
            let resdata=res.data.data
            let optionList = resdata.map(t => {
            return {
               value: t.machine_code,
                label:t.remark
               }
             })
            console.log("optionList")
            console.log(optionList)
            self.optionList=optionList

                let machparam1={type:1}
                self.$axios.post(self.baseApiUrl+'rsa/get_machine_code_list',machparam1).then(function (res) {
                    console.log("get_machine_code_list-res2")
                    console.log(res.data.data)
                    let resdata2=res.data.data
                    let optionList2 = resdata2.map(t => {
                        return {
                            value: t.machine_code,
                            label:t.remark
                           }
                     })
                    self.optionList=self.optionList.concat(optionList2)
                    self.optionValue=self.optionList[0].value
                    self.getRecoredList()

                })

        })
        },





//自动审核开启关闭
editAutoAuditConfig2(){
    let self=this;

    let params={
    is_auto_audit:self.checked?1:0,
    auto_audit_begin_time:self.auto_audit_time?self.auto_audit_time[0]:'',
    auto_audit_end_time:self.auto_audit_time?self.auto_audit_time[1]:'',
    account6_uid:''
    }

    if(self.checked){//关闭
               this.$confirm('是否确认关闭自动审核？', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning',
                      center: true
                }).then(() => {

        this.$axios.post(this.baseApiUrl+'appointment/editAutoAuditConfig',params).then(function (res) {
            console.log("editAutoAuditConfig2-关")
            if(res.code==1){
                self.checked=false
                self.$message({type: 'success',message: '提交成功!'});
                self.onRefresh()
            }
        })
})
    }else{//开启
      if(!self.auto_audit_time||self.auto_audit_time.length==0){
             this.$alert('请先选择时间', {
                 confirmButtonText: '确定',
            });
            return;
        }
this.$axios.post(this.baseApiUrl+'appointment/editAutoAuditConfig',params).then(function (res) {
        console.log("editAutoAuditConfig2-开")
        console.log(res)
    if(res.code==1){
         self.checked=true
        self.$message({type: 'success',message: '提交成功!'});
        self.onRefresh()
        }
})


    }


},



        }


    }
</script>

<style lang="scss" >


</style>



// WEBPACK FOOTER //
// Material.vue?6ce89d3c